import styled from "@emotion/styled/macro";

export const StyledGroup = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
`;
